import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

export default function ReviewMarkdown({ children }: { children: string }) {
  return (
    <div className="review-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        skipHtml
        components={{
          a: ({ href, children }) => (
            <a
              href={href}
              target={href?.startsWith("#") ? undefined : "_blank"}
              rel="noopener noreferrer"
            >
              {children}
            </a>
          ),
          img: ({ alt }) => (
            <span>[Image: {alt || "see submitted attachments"}]</span>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
